import { type Dispatch, type SetStateAction, useMemo } from 'react'
import { Table, type Column, type Row } from '../../../../components/Table'
import { useRequestsQuery } from '../../../../services/hooks/request/queries/useRequestsQuery'
import { type FiltersDomain } from '../../../../types/domain/filters-domain'
import { mapRequestDomainDataToTableRow } from '../utils/mapRequestDomainDataToTableRow'

type Props = {
  columns: Column[]
  filters: FiltersDomain
  setFilters: Dispatch<SetStateAction<FiltersDomain>>
}

export const TableWithManuallyPagination = ({
  columns,
  filters,
  setFilters,
}: Props) => {
  const { data, isLoading } = useRequestsQuery(filters)

  const rows = useMemo(
    () => data?.data?.map(mapRequestDomainDataToTableRow),
    [data]
  )

  return (
    <Table
      columns={columns}
      rows={rows as Row[]}
      noContentMessage="Sem registro de request(s)"
      isLoading={isLoading}
      currentPage={filters.page}
      registersPerPage={filters.take}
      perPageOptions={[5, 10, 15, 20, 50]}
      paginationMode="manual"
      totalCountOfRegisters={data?.meta.itemCount || 0}
      onChangingRegistersPerPage={(registersPerPage) => {
        setFilters((prevState) => ({
          ...prevState,
          page: 1,
          take: registersPerPage,
        }))
      }}
      onPageChange={(pageNumber: number) =>
        setFilters((prevState) => ({
          ...prevState,
          page: pageNumber,
        }))
      }
    />
  )
}
